import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { LlmProviderService } from '../../../../Services/llmProvider.service';
import { LLMCustomerAccess, LLMProviderNames } from '../../../../Model/AI/LLMProvider';

@Component({
    selector: 'llm-customer-access',
    templateUrl: 'llmCustomerAccess.component.html',
    styleUrls: ['llmCustomerAccess.component.css'],
    standalone: false
})
export class LlmCustomerAccessComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  public access: LLMCustomerAccess[] = [];
  public providers = LLMProviderNames;
  public visibleCount = 0;

  constructor(private llmProviderService: LlmProviderService) {
  }

  ngOnInit(): void {
    this.llmProviderService.getCustomerAccess().subscribe(access => this.access = access);
  }

  public onSearch(event: any): void {
    this.dataGrid?.instance?.searchByText(event.value ?? '');
  }

  public onContentReady(event: any): void {
    const count = Math.max(0, event.component.totalCount());
    if (count !== this.visibleCount) {
      this.visibleCount = count;
    }
  }

  public get isFiltered(): boolean {
    return this.visibleCount !== this.access.length;
  }
}
